import { render, staticRenderFns } from "./MaterialCategorySelector.vue?vue&type=template&id=54f53448&"
import script from "./MaterialCategorySelector.vue?vue&type=script&lang=js&"
export * from "./MaterialCategorySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports